import type { AbortLike } from '../abort.ts';

/** `PATCH` is playlist editing; `HEAD` is the instance probe. */
export type HttpMethod = 'GET' | 'POST' | 'PATCH' | 'DELETE' | 'HEAD';

export interface HttpRequest {
  readonly method: HttpMethod;
  readonly url: string;
  readonly headers: Readonly<Record<string, string>>;
  readonly body?: string;
  readonly signal?: AbortLike;
}

export interface HttpResponse {
  readonly status: number;
  /** Lowercase keys. */
  readonly headers: Readonly<Record<string, string>>;
  /** Text only — core never touches binary. Media bytes are the player's business, not core's. */
  readonly body: string;
  /** The URL the response actually came from, after redirects, when the platform can supply it. */
  readonly url?: string;
}

/**
 * R2 — transport is injected. Core never calls `fetch`; this is the whole seam between core and
 * the platform's networking.
 */
export interface HttpClient {
  send(request: HttpRequest): Promise<HttpResponse>;
}

export function isSuccessStatus(status: number): boolean {
  return status >= 200 && status < 300;
}
